export const FETCHING_PLANO_CUIDADO = "planocuidado.buscando_plano";
export const FETCHING_PLANO_CUIDADO_COMPLETE = "planocuidado.buscou_plano";
export const FETCHING_PLANO_CUIDADO_ERROR = "planocuidado.buscou_plano_Error";

export const CLOSE_PLANO_CUIDADO = "planocuidado.finalizar_plano";
export const CLOSE_PLANO_CUIDADO_COMPLETE = "planocuidado.finalizar_plano";
export const CLOSE_PLANO_CUIDADO_ERROR = "planocuidado.finalizar_plano_Error";
